/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddUser.scss';
import fetch from '../../../../../core/fetch';
import { changeLayerStyle } from '../../../../../actions/district';
import ModalAlert from '../../../ModalAlert';
import InputWithValidator from '../../../../InputWithValidator/InputWithValidator';
import { createUser, fetchUser, addRoleToUser } from '../../../../../actions/user';

//fetchPgLayersList what is the path

const fastStyleMargin = {
  marginTop: '7px',
};
const StyleButton = {
  marginTop: '20px',
  //textAlign: 'center'
};

class AddUser extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      adresEmail: this.props.district.nazwaJednostki,
      adres: this.props.district.address,
      gmina: this.props.district.nazwa,
      imie: '',
      nazwisko: '',
      email: '',
      rola: 'wybierz',
      prefix: this.props.district.prefix,
      haslo1: '',
      haslo2: '',
      validImie: true,
      validNazwisko: true,
      validateEmail: true,
      validRola: true,
      validateHaslo1: true,
      validateHaslo2: true,
      validateError: "form-inline"
    };
  }

  onClickNazwaJednostki = (e) => {
    this.setState({nazwaJednostkiSave: this.state.nazwaJednostki})
  };
  onChangeImie= (e) => this.setState({ imie: e.target.value });
  onChangeNazwisko = (e) => this.setState({ nazwisko: e.target.value });
  onChangeAdresEmail = (e) => this.setState({ email: e.target.value });
  onChangeHaslo1 = (e) => this.setState({ haslo1: e.target.value });
  onChangeHaslo2 = (e) => this.setState({ haslo2: e.target.value });

  onClickDodajKonto = () => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const letterRegex = /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]*$/;
    this.setState ({validateEmail: re.test(this.state.email)});
    ((this.state.imie != '' && this.state.imie.length > 2) && letterRegex.test(this.state.imie)) ? this.setState ({validImie: true}) : this.setState ({validImie: false});
    ((this.state.nazwisko != '' && this.state.nazwisko.length > 2) && letterRegex.test(this.state.nazwisko)) ? this.setState ({validNazwisko: true}) : this.setState ({validNazwisko: false});
    this.state.rola != 'wybierz' ? this.setState ({validRola: true}) : this.setState ({validRola: false});
    this.state.haslo1.length >= 8 ? this.setState ({validateHaslo1: true}) : this.setState ({validateHaslo1: false});
    this.state.haslo2 === this.state.haslo1 ? this.setState ({validateHaslo2: true}) : this.setState ({validateHaslo2: false});
    var {
      imie,
      nazwisko,
      email,
      rola,
      prefix,
      haslo1,
      haslo2,
      validImie,
      validNazwisko,
      validateEmail,
      validRola,
      validateHaslo1,
      validateHaslo2,
      validateError
    } = this.state

    if (imie != '' &&
      nazwisko != '' &&
      email != '' &&
      rola != 'wybierz' &&
      haslo1 != '' &&
      haslo2 != '' &&
      validImie && validNazwisko && validateEmail && validRola && validateHaslo1 && validateHaslo2){
      this.props.createUser(imie, nazwisko, email, haslo1, prefix)
      .then(response => {
        this.props.addRoleToUser(prefix, email, rola);
      })
    }
  };

  chooseRole = (e) =>{
    this.setState({
      rola: e.target.value,
    })
  }

  render() {
    var validEmail;
    var validHaslo1;
    var validHaslo2;
    var validImie;
    var validNazwisko;

    this.state.validImie ? validImie = "form-inline" : validImie = "form-inline has-error";
    this.state.validNazwisko ? validNazwisko = "form-inline" : validNazwisko = "form-inline has-error";
    this.state.validateEmail ? validEmail = "form-inline" : validEmail = "form-inline has-error";
    this.state.validateHaslo1 ? validHaslo1 = "form-inline" : validHaslo1 = "form-inline has-error";
    this.state.validateHaslo2 ? validHaslo2 = "form-inline" : validHaslo2 = "form-inline has-error";

    return (
      <div className="col-xs-12">

        <div className="row" >
          <div className={validImie}>
            <label htmlFor="nazwa" className="col-xs-5" style={fastStyleMargin} >Podaj imię</label>
            <input placeholder="imię"  onChange={(e) => this.onChangeImie(e)} name="nazwa" type="text" className="form-control" />
            {!this.state.validImie ? <span className="glyphicon glyphicon-warning-sign form-control"></span> : null}
          </div>
          {!this.state.validImie ? <div style={{textAlign: 'center', color: 'red'}}>Niepoprawne imię</div> : null}
        </div>

        <div className="row" >
          <div className={validNazwisko}>
            <label htmlFor="nazwa" className="col-xs-5" style={fastStyleMargin} >Podaj nazwisko</label>
            <input placeholder="nazwisko"  onChange={(e) => this.onChangeNazwisko(e)} name="nazwa" type="text" className="form-control" />
            {!this.state.validNazwisko ? <span className="glyphicon glyphicon-warning-sign form-control"></span> : null}
          </div>
          {!this.state.validNazwisko ? <div style={{textAlign: 'center', color: 'red'}}>Niepoprawne nawisko</div> : null}
        </div>

        <div className="row" >
          <div className={validEmail}>
            <label htmlFor="nazwa" className="col-xs-5" style={fastStyleMargin} >Podaj adres email</label>
            <input placeholder="nazwa@przyklad.pl"  onChange={(e) => this.onChangeAdresEmail(e)} name="nazwa" type="text" className="form-control" />
            {!this.state.validateEmail ? <span className="glyphicon glyphicon-warning-sign form-control"></span> : null}
          </div>
          {!this.state.validateEmail ? <div style={{textAlign: 'center', color: 'red'}}>Niepoprawny email</div> : null}
        </div>

        <div className="row" style={fastStyleMargin}>
          <div className="form-inline">
            <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Wybierz rolę</label>
            <select
              name="selectRole"
              className="form-control"
              onChange={(e) => this.chooseRole(e)}
              value={this.state.rola}
            >
              <option value="wybierz" disabled>Wybierz rolę</option>
              {this.props.district.roles.map((v, i) => <option value={v.nazwa} key={i}>{v.nazwa}</option>)}
            </select>
            {!this.state.validRola ? <div style={{textAlign: 'center', color: 'red'}}>Wybierz rolę</div> : null}
          </div>
        </div>

        <br/>
          <div className="row">
            <div className="form-inline" style={{borderTop: '1px solid grey', color: 'grey'}}>
            </div>
          </div>
        <br/>

          <div className="row" style={fastStyleMargin}>
            <div className={validHaslo1}>
              <label htmlFor="adres" className="col-xs-5" style={fastStyleMargin}>Podaj hasło</label>
              <input name="adres" type="password" className="form-control" onChange={(e) => this.onChangeHaslo1(e)} value={this.state.haslo1} />
              {!this.state.validateHaslo1 ? <span className="glyphicon glyphicon-warning-sign form-control"></span> : null}
            </div>
            {!this.state.validateHaslo1 ? <div style={{textAlign: 'center', color: 'red'}}>Niepoprawne hasło - musi zawierac minium 8 znaków BEZ spacji</div> : null}
          </div>

          <div className="row" style={fastStyleMargin}>
            <div className={validHaslo2}>
              <label htmlFor="warstwa" className="col-xs-5" style={fastStyleMargin}>Powtórz hasło</label>
              <input name="warstwa" type="password" className="form-control" onChange={(e) => this.onChangeHaslo2(e)} value={this.state.haslo2} />
              {!this.state.validateHaslo2 ? <span className="glyphicon glyphicon-warning-sign form-control"></span> : null}
            </div>
            {!this.state.validateHaslo2 ? <div style={{textAlign: 'center', color: 'red'}}>Niepoprawnie powtórzone hasło</div> : null}
          </div><br/>

          <div className="row">
            <div className="form-inline" style={{textAlign: 'center', margin: '10px'}}>
              <button onClick={this.onClickDodajKonto} type="button" className="btn btn-danger">Dodaj konto</button>
            </div>
          </div>

      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});

const mapDispatch = {
  createUser,
  fetchUser,
  addRoleToUser,
};

const SubObject = connect(mapState, mapDispatch)(AddUser);


export default withStyles(s)(SubObject);




// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddUser/AddUser.js